export const EMULATION_AUTH_COMPLETE = 'EMULATION_AUTH_COMPLETE'
